export default __webpack_public_path__ + "img/5d87f0b46580cb5a2aee0cbf71890a36.svg";